import { jsx as _jsx } from "react/jsx-runtime";
export function Select({ className, children, ...props }) {
    return (_jsx("div", { className: ['dhk8-select', className ?? ''].filter(Boolean).join(' '), children: _jsx("select", { ...props, children: children }) }));
}
//# sourceMappingURL=Select.js.map